/* eslint-disable @next/next/no-img-element */
import React from "react";
import {
  SectionContainerBase,
  IconTitleDescriptionActionCard,
} from "@reusejs/react";
import { BadgeCheckIcon } from "@heroicons/react/outline";
import { CheckCircleIcon } from "@heroicons/react/solid";
import VerifiedSvg from "../../Icons/VerifiedSvg";
import { getWatermarkedImgixUrl } from "services";

const data = [
  {
    title: "Property Documents",
  },
  {
    title: "Property Photos",
  },
  {
    title: "Property Location",
  },
];

const Actions = () => {
  return (
    <div className="flex flex-col sm:flex-row py-8">
      {data.map((item, index) => (
        <div className="flex items-center" key={index}>
          <CheckCircleIcon className="h-6 w-6 text-blue-600 mr-1" />
          <div className="text-gray-500 mr-6">{item.title}</div>
        </div>
      ))}
    </div>
  );
};

export default function AuctionBazaarVerifiedComponent() {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "py-20 bg-gray-50",
        innerContainerStyles: "max-w-7xl mx-auto",
      }}
    >
      <div className="mx-4 pl-4 pr-4 sm:pr-0 sm:pl-6 lg:pl-8 shadow-lg rounded-xl">
        <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
          <div>
            <h3 className="text-xl flex sm:flex-row whitespace-nowrap justify-center sm:justify-start items-center font-extrabold sm:text-4xl">
              Auction Bazaar{"  "}
              <span className="text-blue-600 ml-1 sm:ml-2">verified</span>
              <BadgeCheckIcon className="h-6 w-6 sm:h-8 sm:w-8 text-blue-600 ml-1 sm:ml-2" />
            </h3>
            <IconTitleDescriptionActionCard
              title={"Properties verified by Auction bazaar experts."}
              description={
                "Check out the collection of best properties from multiple cities hand selected and verified by Auction bazaar team."
              }
              actions={<Actions />}
              itemTitleDescriptionCardBaseClasses={{
                iconWrapper:
                  "flex h-12 w-12 items-center rounded-md text-white",
                titleWrapper: "mt-2 text-center sm:text-start",
                titleStyles: "text-xl font-bold sm:text-2xl",
                descriptionWrapper: "mt-3 sm:mt-4 max-w-3xl mx-auto",
                descriptionStyles:
                  "text-lg text-center sm:text-start text-gray-500",
                actionWrapper: "mt-2 text-left",
              }}
            />
          </div>
          <div className="relative flex justify-end ">
            <div className="absolute left-0 sm:left-36 sm:top-8">
              <VerifiedSvg />
            </div>
            <img
              className="rounded-r-lg rounded-l-lg sm:rounded-l-none "
              src={getWatermarkedImgixUrl(
                `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/206f0057-0418-4673-a8ff-f7cdbf97c76e?fit=fill&auto=format`,
              )}
              alt=""
            />
          </div>
        </div>
      </div>
    </SectionContainerBase>
  );
}
